import { DashboardService } from "./../dashboard/dashboard.service";
import { Intercom } from "@supy-io/ngx-intercom";
import { ConversationsService } from "./../dashboard/conversations/conversations.service";
import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { Router, RouterLink } from "@angular/router";
import { LoginService } from "./login.service";
import { HotToastService } from "@ngneat/hot-toast";
import { environment } from "../../environments/environment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { SmsVerificationModalComponent } from "../dashboard/main/common/modals/sms-verification-modal.component";
import { NgxTurnstileModule } from "ngx-turnstile";
import {
  SharedDataService,
  SubscriptionType,
} from "../dashboard/shared-data.service";
import { FormsModule } from "@angular/forms";
import { NgIf } from "@angular/common";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  imports: [NgIf, RouterLink, FormsModule, NgxTurnstileModule],
})
export class LoginComponent implements OnInit {
  public email: String = "";
  public password: String = "";

  public remember = true;
  logo = "assets/img/logo-default.svg";
  loadingLogo = false;
  captchaPassed = true;
  isLoading: boolean = false;

  env = environment;

  constructor(
    public loginService: LoginService,
    public localStorage: LocalStorageService,
    public router: Router,
    public toastr: HotToastService,
    public conversationsService: ConversationsService,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,

    private sharedDataService: SharedDataService,
  ) {}

  ngOnInit(): void {
    this.loadingLogo = true;
    this.loginService.getBrandInfo().then((res: any) => {
      this.logo = res ?? "assets/img/logo-default.svg";
      this.loadingLogo = false;
    });

    if (
      this.loginService.get_access_token() !== undefined &&
      this.loginService.get_access_token() != null
    ) {
      this.loginService.loginToFirestore(true);
    }
  }

  async login() {
    if (this.email === "" || this.password === "") {
      this.toastr.error("Email/Password cannot be empty");
      return;
    } else {
      this.isLoading = true;
      this.loginService.login(this.email, this.password).then(
        async (res: any) => {
          console.log("Login Response", res);
          if (res.verification_required != null) {
            this.bsModalRef = this.modalService.show(
              SmsVerificationModalComponent,
              {
                class: "modal-md modal-white-bg",
                initialState: {
                  fromLogin: true,
                  userUuid: res.user_uuid,
                  mockNumber: res.mock_number,
                },
              },
            );

            this.bsModalRef.content.onClose.subscribe((result) => {
              console.log("results", result);
              if (result.verified == true) {
                this.login();
              }
            });
          } else {
            this.localStorage.set("remember", this.remember);
            this.localStorage.set("user", res.user);
            this.localStorage.set("data", res.data);
            this.localStorage.set("company", res.company);
            this.localStorage.set("subscription_type", res.subscription_type);

            this.sharedDataService.subscriptionType = res.subscription_type;
            this.sharedDataService.data = res.data;
            this.sharedDataService.company = res.company;
            this.sharedDataService.user = res.user;

            console.log("company?", this.localStorage.get("company"));
            if (this.remember) {
              this.localStorage.set("access_token", res.access);
              this.localStorage.set("refresh_token", res.refresh);
            } else {
              sessionStorage.setItem("access_token", res.access);
              sessionStorage.setItem("refresh_token", res.refresh);
            }

            this.loginService.loginToFirestore(true, true);
          }
        },
        (err) => {
          console.log(err);
          this.toastr.error(err.error.message);
          this.isLoading = false;
          return;
        },
      );
    }
  }

  captchaResponse(event) {
    this.captchaPassed = true;
  }

  captchaError(event) {
    this.captchaPassed = false;
  }
}
